<script>
    import R, {LOADER} from "../lib/requests";
    import app  from "../stores/app";
    import user from "../stores/user.js";
    import Alert from "../stores/alerts.js";
    import {setFocusTo} from "../lib/lib.js";
    import PointsPanel from "../account/PointsPanel.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import PageInfo from "../components/pages/PageInfo.svelte";

    let points = null;
    let maxPoints = null;
    let email = null;
    let pointsToTransfer = 10;
    let error = null;
    let step = 1;


    const findAccount = () => {
        const onSuccess = result => {
            error = null;
            step = 2;
        }

        const onFailure = err => {
            if (err.code === 'no_login') {
                error = "You are signed out of your account.|Please login and repeat this process.";
            }
            if (err.code === 'not_found') {
                error = "No member was found with the email you entered!";
                setFocusTo('transferEmail');
                return;
            }
            if (err.code === 'same_object_identifier') {
                error = "You cannot transfer points to yourself!";
                setFocusTo('transferEmail');
                return;
            }
            if (err.code === 'insufficient_points') {
                error = "You don't have enough points to transfer!";
                setFocusTo('transferPoints');
            }
        }

        let data = {
            email,
            points: pointsToTransfer
        }

        R.handle(R.member.validatePointsTransfer, data, onSuccess, onFailure, LOADER.POPUP);
    }

    const submit = () => {
        const onSuccess = result => {
            error = null;
            step = 3;
            if ($app.debugNotifications) {
                Alert.alert("DEBUG!", `Member gets this link on his email:\n<a href="${result}" target="_blank">${result}</a>`);
            }
        }

        const onFailure = err => {
            step = 1;
            if (err.code === 'not_found') {
                error = "No member was found with the email you entered!";
                setFocusTo('transferEmail');
                return;
            }
            if (err.code === 'same_object_identifier') {
                error = "You cannot transfer points to yourself!";
                setFocusTo('transferEmail');
                return;
            }
            if (err.code === 'insufficient_points') {
                error = "You don't have enough points to transfer!";
                setFocusTo('transferPoints');
            }
        }


        let data = {
            action: 'transfer-points',
            data: {
                email,
                points: pointsToTransfer
            },
        }

        R.handle(R.actionRequest.request, data, onSuccess, onFailure, LOADER.POPUP);
    }
</script>

<div class="page-header solid">
    <h1>Transfer Points</h1>
</div>
<div class="page page-padding">
    {#if $user.token}
        <div class="page-wrapper align-center">
            <PointsPanel bind:points={ points } bind:max={ maxPoints }/>

            {#if points != null}
                <div class="panel-simple box-shadow rounded panel-pad">
                    {#if step == 1}
                        <p>
                            Enter the email of the member you want to transfer points to.
                        </p>
                        <form on:submit|preventDefault|stopPropagation="{ findAccount }">
                            <div class="form-group">
                                <label class="text-gray small">Member email</label>
                                <input type="email" class="form-control" id="transferEmail" bind:value="{ email }"
                                       required>
                            </div>
                            <div class="form-group">
                                <label class="text-gray small">Points to transfer</label>
                                <input type="number" class="form-control" id="transferPoints"
                                       bind:value="{ pointsToTransfer }"
                                       required>
                            </div>
                            {#if error}
                                <div class="alert alert-danger mb-3">
                                    { error }
                                </div>
                            {/if}
                            <div class="text-end">
                                <button class="btn btn-primary rounded px-4">
                                <span class="d-flex">
                                    Next <AppIcon icon="chevron-right" strokeWidth="2" cssClass="ms-1"/>
                                </span>
                                </button>
                            </div>
                        </form>
                    {:else if step == 2}
                        <p>
                            You are about to transfer <b>{ pointsToTransfer }</b> points to member <b>{ email }</b>.
                        </p>
                        <p>
                            The member will be notified by email and your points will be removed from your account and
                            transferred to the member once the member accepts the process.
                        </p>
                        <hr>
                        <div class="text-end">
                            <button class="btn btn-primary rounded px-4" on:click={ submit }>
                                <span class="d-flex">
                                    <AppIcon icon="circle-check" strokeWidth="2" cssClass="me-2"/> Finish
                                </span>
                            </button>
                        </div>
                    {:else if step == 3}
                        <p>
                            You sent a request to member <b>{ email }</b> to transfer <b>{ pointsToTransfer }</b> points
                            to his
                            account.
                        </p>
                        <p>
                            When the member accepts your request the transfer will be completed and the points will be
                            deducted from your account and added to the member's account.
                        </p>
                    {/if}
                </div>
            {/if}
        </div>
    {:else}
        <PageInfo icon="user" message="You must log in to your account!"/>
    {/if}
</div>